import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable()
export class GlobalsPaths {
  img = environment.imgHost; // /client/dist/assets/images/
  safetyInspectionApp = environment.safetyInspectionAppUrl;
  safetyInspectionApiHost = environment.safetyInspectionApiHost;
  defectApp = environment.defectAppUrl;
  defectApiHost = environment.defectApiHost;
}

export class GoogleMapsKey {
  mapsKey = 'AIzaSyBjP410aGh_1d09yFmNQ36ljwC5wcyurlw';
  placeKey = 'AIzaSyCdpHD_NW15ipHOv2ca5D8vAWEfp8-l_vU';
  newKey = 'AIzaSyDmbRsQfIbAGVwt2y_4T560tf3nsx2ZUyw'
}

@Injectable()
export class APIsettings {
  pagingPageSize: 50;
  pagingPageSizeOptions: [25, 50, 75];
  pagingPageSizeForNonPaginationLists: 200;
  apiDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss[Z]';
  apiDateFormat = 'YYYY-MM-DD';
  apiDateTimeFormatUI = 'DD MMM, HH:mm:ss';
}

export class Units {
  metersToMile = 1609; // For use in mile to km conversion. 1 mile = 1609 metres.
}




// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/app.config.ts